/**
 * Created by fers on 22/11/16.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {injectIntl, FormattedMessage, IntlShape} from 'react-intl';
import ChannelIcon from '../../channel-defs/ChannelIcon.react';
import EntityDefIcon from '../../channel-defs/EntityDefIcon.react';
import {getMessageArgsForDataSource} from './DataSourceList.react';
import {getEditDataSourceFragment} from './../box-utils/ScreenDisplayer.react';
import {assert} from 'chai';


class DataSourceInfo extends React.Component {
    static propTypes = {
        dataSource: PropTypes.object.isRequired,
        dataSourceList: PropTypes.object.isRequired,
        idx: PropTypes.number,
        intl: PropTypes.object,
        screen: PropTypes.object.isRequired,
        screenSettings: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);

    }

    render() {
        let dataSource = this.props.dataSource;
        assert.isDefined(dataSource);

        let idx = this.props.idx;

        let messageArgs = getMessageArgsForDataSource(dataSource, dataSource.relativeTo);

        let name = this.props.intl.formatMessage({
            id: 'dataSource.' + dataSource.typeId + '.name',
        }, messageArgs);

        let description = this.props.intl.formatMessage({
            id: 'dataSource.' + dataSource.typeId + '.description',
        }, messageArgs);

        if (dataSource.entityDefs && dataSource.entityDefs.length > 0) {
            return (
                <div className="dataSource-item-box" key={idx}>
                    <div className="dataSource-item-detail">
                        <div className="dataSource-head flex">
							<div className={"dataSource-item-close"}>
								<div className="btn btn-inline" onClick={this.props.dataSourceList.goBack}><span className="fa fa-chevron-left"/></div>
							</div>
                            <div className="dataSource-idx-box">
                                <span className="dataSource-idx" title={description}>#{dataSource.idx}</span>
                            </div>
                            <div className="dataSource-title-icon">
                                {dataSource.channelDefs && dataSource.channelDefs.length > 0 ? dataSource.channelDefs.map((channelDef, idx) => channelDef.icon ? <ChannelIcon channelDef={channelDef} key={idx} size={32} /> : null) : <ChannelIcon channelDef={{icon: 'dativery'}} size={32} />}
                            </div>
                            <div className={"dataSource-item-title" + (description ? '' : ' one-line-title')}>
                                <h3>{name}</h3>

                                {description ? <small>{description}</small> : null}
                            </div>
                        </div>

                        <div className="dataSource-item-dataSources">
                            <p style={{padding: '.6em'}}><strong><FormattedMessage defaultMessage="Returned type:" id="dataSource.returns" /></strong> {dataSource.entityDefs && dataSource.entityDefs.length > 0 ? dataSource.entityDefs.map((entityDef, idx) => <span key={idx}>{idx > 0 ? ", " : null}{entityDef.icon ? <EntityDefIcon icon={entityDef.icon} size={32} /> : null}{" "}{entityDef.name} (<code>{entityDef.key}</code>)</span>) : null}</p>

                            <table className="table">
								<thead>
									<tr>
										<th><FormattedMessage defaultMessage="Name" id="dataSource.column.name" /></th>
										<th><FormattedMessage defaultMessage="Key" id="dataSource.column.key" /></th>
										<th><FormattedMessage defaultMessage="ID" id="dataSource.column.id" /></th>
									</tr>
								</thead>
                                <tbody>
                                    {dataSource.mappedFields.map((fieldDef, idx) => {
                                        return (
                                            <tr key={idx}>
                                                <td>{fieldDef.name}</td>
                                                <td><code>{fieldDef.entityDef ? fieldDef.entityDef.key : ''}@{fieldDef.key}</code></td>
                                                <td>{fieldDef.realId}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

export default Relay.createContainer(injectIntl(DataSourceInfo), {
    initialVariables: {
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        dataSource: () => {
            return Relay.QL`
                fragment on DataSource {
                    id,
                    realId,
                    typeId,
                    mappedFields {
                        id,
                        realId,
                        name,
                        key
                        entityDef {
                            id,
                            realId,
                            name,
                            key
                        }
                    },
                    relativeTo {
                        entityDefs {
                            id,
                            name,
                        },
                        channelDefs {
                            id,
                            name,
                        }
                    },
                    entityDefs {
                        id,
                        icon,
                        realId,
                        name,
                        key
                    }
                    ${getEditDataSourceFragment()}
                }`;
        }
    }
});
